export default __webpack_public_path__ + "static/media/previous.ce8133c1.svg";